import React, { ChangeEvent, useState } from 'react';
import { Stack, FormControl, Select, InputLabel, MenuItem, Box, Grid, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, SelectChangeEvent } from '@mui/material/';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs'; 
import FilerFine from '../dataObjects/FilerFine';
import { WaiverStatusTypeEnums } from '../dataObjects/WaiverStatusTypeEnums';
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
interface EditFineDialogProps {
    isEditFineDialogOpen: boolean,
    closeEditFineDialog: (reload:boolean) => void,
    currentFineInfo: FilerFine | null;
}

const EditFineDialog = (props: EditFineDialogProps): JSX.Element => {

    const defaultPaymentTender = props.currentFineInfo?.finePaymentTender ? props.currentFineInfo.finePaymentTender : '1';

    // Seed the tender into the save state too; otherwise the Select shows "Check" but nothing is sent unless the user changes it
    const [currentFine, setCurrentFine] = useState(props.currentFineInfo ? { ...props.currentFineInfo, finePaymentTender: defaultPaymentTender } : null);

    const [finePaymentTender, setFinePaymentTender] = useState(defaultPaymentTender);

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        console.log('Updating field:', name, 'with value:', value); 
        console.log(currentFine);
        setCurrentFine((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Specific handleChange for MUI Select
    // This uses Mui's specific SelectChangeEvent type
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        setFinePaymentTender(event.target.value as string);
        const { name, value } = event.target; // event.target.name works if the 'name' prop is set on MuiSelect
        setFinePaymentTender(value);
        setCurrentFine((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Specific handleChange for MUI DatePicker
    const handleDateChange = (date: Dayjs | null) => {
        setCurrentFine((prevData: any) => ({
            ...prevData,
            fineDatePaid: date?.toDate().toLocaleDateString(),
        }));
    };

    //handle save 
    const handleSaveFiler = async () => {
        console.log(currentFine);
        try {
            if (currentFine) {
                let fineAmountPaid = Number(currentFine?.fineAmountPaid?.replace(/[^0-9.-]+/g, ""));
                // Skip empty values so the server sees null instead of the strings "null"/"undefined"
                const values: Record<string, unknown> = {
                    FineIssueId: currentFine.fineIssueId,
                    FineDatePaid: currentFine.fineDatePaid,
                    FineAmountPaid: currentFine.fineAmountPaid ? fineAmountPaid : null,
                    FinePrivateNote: currentFine.finePrivateNote,
                    FinePaymentTender: currentFine.finePaymentTender,
                    FineCheckNumber: currentFine.finePaymentTender === '1' ? currentFine.fineCheckNumber : null,
                };
                const params = new URLSearchParams();
                Object.entries(values).forEach(([key, value]) => {
                    if (value !== null && value !== undefined && value !== '') {
                        params.append(key, String(value));
                    }
                });
                const url = `/fineTracker/UpdateFineInfo?${params}`;
                const method = 'POST';

                const response = await fetch(url, {
                    method: method,
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(currentFine)
                });

                if (response.ok) {
                    props.closeEditFineDialog(true);
                } else {
                    console.error('Failed to update fine payment');
                    let info = {
                        type: 'error',
                        title: 'Error: UpdateFineInfo',
                        errorMessage: `An error occurred while processing your request.`,
                        secondaryErrorMessage: ''
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
            }
        } catch (error) {
            console.error('Error updating fine info:', error);
        }
    };

    return (
        <>
        {
            props.currentFineInfo &&
                <Dialog
            open={props.isEditFineDialogOpen}
            onClose={props.closeEditFineDialog}
            fullWidth={true}
            maxWidth={'sm'}
        >
            <DialogTitle>
                    <Typography component='i' variant="subtitle1" fontWeight={550}>
                            Edit Fine: {props.currentFineInfo.cpfId} {props.currentFineInfo.fullName}
                    </Typography>
            </DialogTitle>
            <DialogContent dividers>


                <Grid rowSpacing={2} container display={'flex'} justifyContent="center">
                    <Grid item xs={12}>
               
                    <Box>
                        <Typography variant="subtitle1">
                                Audit Period: {props.currentFineInfo.auditPeriodId}
                        </Typography>
                        <Typography variant="subtitle1" fontWeight={550} color="error">
                                Fine: {props.currentFineInfo.modifiedFineAmount}
                        </Typography>
                        <Typography variant="subtitle1">
                                Director Decision:
                                            {
                                                props.currentFineInfo.waiverStatus === WaiverStatusTypeEnums.None ?
                                                    <Typography variant="subtitle1" component="i" padding={1} >
                                                        No Waiver Submitted
                                                    </Typography> :
                                                    <Typography variant="subtitle1" component="i" padding={1}>
                                                        {props.currentFineInfo.waiverDecisionTypeDescription}
                                                    </Typography>
                                                
                                            }
                        </Typography>

                    </Box>
                
                    </Grid>

                    <Grid item xs={12}>
                        <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                            <Typography variant="subtitle1" fontWeight={550} width={150}>
                                Date Paid:
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker onChange={handleDateChange} sx={{ minWidth: 100, width: 350 }} defaultValue={props.currentFineInfo.fineDatePaid ? dayjs(props.currentFineInfo.fineDatePaid) : null} name="fineDatePaid" label="Date" />
                            </LocalizationProvider>
                   
                        </Stack>
                    </Grid>


                    <Grid item xs={12}>

                        <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                            <Typography variant="subtitle1" fontWeight={550} width={150}>
                                Payment Tender:
                            </Typography>
                            <FormControl>
                                <InputLabel>Type</InputLabel>
                                            <Select
                                                defaultValue={props.currentFineInfo.finePaymentTender ? props.currentFineInfo.finePaymentTender : '1'}
                                                label="Type"
                                                onChange={handleSelectChange}
                                                name="finePaymentTender"
                                                sx={{ width: finePaymentTender === '1' ? 150 : 400 }}
                                >
                                    <MenuItem value={'1'}>Check</MenuItem>
                                    <MenuItem value={'2'}>Cash</MenuItem>
                                    <MenuItem value={'3'}>Credit Card/MassPay</MenuItem>
                                    <MenuItem value={'4'}>Transfer</MenuItem>
                                    <MenuItem value={'7'}>Money Order</MenuItem>
                                </Select>
                            </FormControl>
                             {finePaymentTender === '1' && <TextField sx={{ width: 190 }} defaultValue={props.currentFineInfo.fineCheckNumber} name='fineCheckNumber' onChange={handleChange} label="Check #" variant="outlined" />}
                        </Stack>


                    </Grid>

                    <Grid item xs={12}>

                        <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                            <Typography variant="subtitle1" fontWeight={550} width={150}>
                                Amount Paid:
                            </Typography>
                            <TextField sx={{ width: 350 }} name="fineAmountPaid" onChange={handleChange} defaultValue={props.currentFineInfo.fineAmountPaid} label="Amount Paid" variant="outlined" />
                        </Stack>

                    </Grid>

                    {/*<Grid item xs={12}>*/}

                    {/*    <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">*/}
                    {/*        <Typography variant="subtitle1" fontWeight={550} width={150}>*/}
                    {/*            Director Decision:*/}
                    {/*        </Typography>*/}
                    {/*        <Typography variant="subtitle1" gutterBottom>*/}
                    {/*            {props.currentFineInfo.directorWaiverDecisionNote}*/}
                    {/*        </Typography>*/}

                    {/*    </Stack>*/}

                    {/*</Grid>*/}

                    <Grid item xs={12}>

                        <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                            <Typography variant="subtitle1" fontWeight={550} width={150}>
                               (Private) Note:
                            </Typography>
                                        <TextField
                                            onChange={handleChange}
                                sx={{width: 350} }
                                label="Notes"
                                multiline
                                            rows={4}
                                            name="finePrivateNote"
                                            defaultValue={props.currentFineInfo.finePrivateNote}
                            />
                        </Stack>

                    </Grid>
                </Grid>
       

            </DialogContent>
            <DialogActions>
                <Button size="small" color="warning" onClick={()=>props.closeEditFineDialog(false)}>Cancel</Button>
                            <Button size="small" onClick={handleSaveFiler}>Save</Button>
            </DialogActions>
        </Dialog >
            }

            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )
}

  export default EditFineDialog;